import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import Toast from "@/partials/Toast";
import vSelect from "vue-select";
import Pagination from "laravel-vue-pagination";
import Datepicker from "vue-flatpickr-component";

//signature pad
import VueSignaturePad from "vue-signature-pad";

// CSS Modules
import "animate.css";
import "leaflet/dist/leaflet.css";
import "@/assets/scss/_index.scss";

const app = createApp(App);

// Keep Vue 2-style translation access available in Vue 3
app.config.globalProperties.$t = i18n.global.t;
app.config.globalProperties.$te = i18n.global.te;
app.config.globalProperties.$d = i18n.global.d;
app.config.globalProperties.$n = i18n.global.n;
app.config.globalProperties.$i18n = i18n;

// Register global components
app.component("Toast", Toast);
app.component("Pagination", Pagination);
app.component("VSelect", vSelect);
app.component("Datepicker", Datepicker);

// Use plugins
app.use(store);
app.use(i18n);
app.use(router);
app.use(VueSignaturePad);

// Global properties
app.config.globalProperties.$hasGlobalPermission = (permission) =>
  store.getters.hasGlobalPermission(permission);
app.config.globalProperties.$hasTeamPermission = (permission, teamId) =>
  store.getters.hasTeamPermission(permission, teamId);
app.config.globalProperties.$canAccessAnyTeam = (permission) => {
  if (store.getters.isSuperAdmin) {
    return true;
  }

  const teamIds = store.getters.authorizedTeamIds(permission);
  return teamIds === null || teamIds.length > 0;
};

app.mount("#app");
